import React from 'react'
import { H2 } from '../typography'
import Separator from '../separator'

export default function QuickGlanceHeader({ title, id }) {
  return title ? (
    <>
      {typeof title !== 'string' ? (
        title
      ) : (
        <H2 size="H5" id={id}>
          {title}
        </H2>
      )}
      <Separator size="xs" />
    </>
  ) : null
}
